import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import { CASE_TYPE } from '@demandproai/shared';

const useCaseLiabilityTextFields = () => {
  const { formik, selectedDefendant, debounceUpdateCase } = useAddCaseFormContext();

  const caseType = formik.values.caseInfo?.caseType;

  const isAutoAccident = caseType === CASE_TYPE.AUTO_ACCIDENT;
  const isDogBite = caseType === CASE_TYPE.DOG_BITE;
  const isPremiseLiability = [
    CASE_TYPE.TRIP_AND_FALL,
    CASE_TYPE.SLIP_AND_FALL,
    CASE_TYPE.PREMISE_LIABILITY
  ].includes(caseType);

  const shouldRender = isDogBite || isPremiseLiability || isAutoAccident;

  const getFieldValue = (fieldName) => {
    return formik.values.liability?.[fieldName]?.[selectedDefendant]?.text || '';
  };

  const getFieldName = (fieldName) => {
    return `liability.${fieldName}[${selectedDefendant}].text`;
  };

  const handleChange = ({ fieldName, value }) => {
    const defendantId = formik.values.defendants[selectedDefendant]?.defendantId;

    if (!defendantId) {
      console.warn('⚠️  Defendant ID not found for index:', selectedDefendant);
      return;
    }

    const fieldPath = `liability.${fieldName}[${selectedDefendant}]`;
    formik.setFieldValue(`${fieldPath}.text`, value);
    formik.setFieldValue(`${fieldPath}.defendants`, [defendantId]);

    const mongoPath = `liability.${fieldName}.${selectedDefendant}`;
    debounceUpdateCase({
      data: {
        [`${mongoPath}.text`]: value,
        [`${mongoPath}.defendants`]: [defendantId]
      }
    });
  };

  return {
    shouldRender,
    isPremiseLiability,
    getFieldValue,
    getFieldName,
    handleChange
  };
};

export default useCaseLiabilityTextFields;
